/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonSharedFinancialPaymentMethodDropdownQueryResponse,
  GetApiV1PersonSharedFinancialPaymentMethodDropdown401,
  GetApiV1PersonSharedFinancialPaymentMethodDropdown500,
} from "../../types/personSharedController/GetApiV1PersonSharedFinancialPaymentMethodDropdown.ts";

function getGetApiV1PersonSharedFinancialPaymentMethodDropdownUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/person/shared/financial-payment-method-dropdown` as const,
  };
  return res;
}

/**
 * @description Retorna todas as opções do enumerador EPersonFinancialPaymentMethod para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Lista de formas de pagamento financeiro pessoal para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/financial-payment-method-dropdown}
 */
export async function getApiV1PersonSharedFinancialPaymentMethodDropdown(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonSharedFinancialPaymentMethodDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedFinancialPaymentMethodDropdown401
      | GetApiV1PersonSharedFinancialPaymentMethodDropdown500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonSharedFinancialPaymentMethodDropdownUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
